import { useEffect, useRef } from 'react';

function useRunOnce({ mount, unmount }) {
	const triggered = useRef(false);

	useEffect(() => {
		const isTriggered = triggered.current;

		if (!isTriggered) {
			mount();
			triggered.current = true;
		}

		return () => {
			if (unmount) unmount();
		};
	}, [mount, unmount]);

	return null;
}

export default useRunOnce;
